import SearchProvidersView from "./search-providers-view";

const SearchProviders = () => <SearchProvidersView />;

export default SearchProviders;
